// src/services/axios.js
import { FRONTEND_API_TIMEOUT_MS, SLEEP_TIME_API } from '@/constants';
import { logoutOtp, refreshTokenCall } from '@/redux/thunk/auth-thunk';
import { sleep } from '@/utils';
import axios, { HttpStatusCode } from 'axios';
// import store from "@/redux/store";
// import { setAccessToken } from "@/redux/reducers/auth-reducer";
// import { logoutOtp, refreshTokenCall } from "@/redux/thunk/auth-thunk";

let store;

export const injectStore = (_store) => {
  store = _store;
};

const axiosClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_APP_URL,
  timeout: FRONTEND_API_TIMEOUT_MS,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach token to requests
axiosClient.interceptors.request.use(
  (config) => {
    const state = store?.getState();
    const token = state?.auth?.accessToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);
axiosClient.interceptors.response.use((response) => response);

export const axiosWithAuth = () => {
  const axiosClientWithAuth = axios.create({
    baseURL: process.env.NEXT_PUBLIC_APP_URL,
    timeout: FRONTEND_API_TIMEOUT_MS,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  axiosClientWithAuth.interceptors.request.use(
    (config) => {
      const state = store?.getState();
      const token = state?.auth?.accessToken;
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    },
    (error) => Promise.reject(error),
  );
  axiosClientWithAuth.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      if (error.response?.status === HttpStatusCode.Gone) {
        try {
          const result = await store?.dispatch(refreshTokenCall()).unwrap();
          originalRequest.headers.Authorization = `Bearer ${result.accessToken}`;
          await sleep(SLEEP_TIME_API);
          return axiosClient(originalRequest);
        } catch (refreshError) {
          store.dispatch(logoutOtp()); // Log out if refresh fails
          return Promise.reject(refreshError);
        }
      }
      return Promise.reject(error);
    },
  );
  return axiosClientWithAuth;
};

export default axiosClient;
